export const SET_DYNAMIC_BREADCRUMS = "@@CONFIGURATION/SET_DYNAMIC_BREADCRUMS";
